export enum ApiError {
  Other = 'OTHER',
  Network = 'NETWORK',
  Unauthorized = 'UNAUTHORIZED',
}

export interface Loadable<T> {
  value?: T;
  loading: boolean;
  loaded: boolean;
  error?: ApiError | undefined;
}

export enum MembershipLabel {
  MEMBERSHIP = 'MEMBERSHIP',
  SUBSCRIPTION = 'SUBSCRIPTION',
}

export interface WhiteLabel {
  id: string;
  accountId: string;
  supportEmail: string;
  supportLink: string;
  privacyLink: string;
  termsLink: string;
  senderEmail: string;
  enabled: boolean;
}

export interface AccountSettings {
  id: string;
  accountId: string;
  defaultLandingUrl: string;
  productFormLoginUrl: string;
  productFormLoginRedirectParameter: string;
  productFormLoginButtonText: string;
  productFormAlreadyPurchasedButtonText: string;
  productFormSoldOutButtonText: string;
  membershipLabel: MembershipLabel;
  alreadyMemberText: string;
  postsTabTitle: string;
  videoTabTitle: string;
  merchTabTitle: string;
  codesTabTitle: string;
  musicTabTitle: string;
  showPhoneField: boolean;
  showBirthdayField: boolean;
  showZipCodeField: boolean;
  showMarketingOptIn: boolean;
  showFirstName: boolean;
  showLastName: boolean;
  showPostAuthor: boolean;
  cardBackgroundColor: string;
  cardBorderColor: string;
  cardTextColor: string;
  cardButtonBackgroundColor: string;
  cardButtonTextColor: string;
  secondaryButtonBackgroundColor: string;
  secondaryButtonTextColor: string;
  bannerImageFileSetId: string;
  bannerImageUrl: string;
  header: string;
  subheader: string;
  showBanner: boolean;
  borderWidth: string;
  borderRadius: string;
  pageWidth: string;
  showCompleteProfileCard: boolean;
  showClaimWalletPass: boolean;
  enableCommunitySubmissions: boolean;
}

export interface AccountSettingsResponse {
  accountSettings: AccountSettings;
  whiteLabel: WhiteLabel;
  displayPoweredBy: boolean;
}

export enum CustomerAccountsVersion {
  Classic = 'CLASSIC',
  NewCustomerAccounts = 'NEW_CUSTOMER_ACCOUNTS',
  Unknown = 'UNKNOWN',
}

export interface CustomerAccountsSettings {
  customerAccountsVersion: CustomerAccountsVersion;
}
